// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sehR","colBig":"styles_colBig__ggiYc","colSmall":"styles_colSmall__1MYjf"};